export function isNullOrEmpty(variable: string | null | undefined) {
    return !variable || variable.trim() === "";
}

export function getElementOffsetPos(section: HTMLElement | null) {
    if (section != null) {
        const elementPosition = section.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - 50;

        return offsetPosition;
    }
}

export function scrollToSectionEvent(e: React.MouseEvent<HTMLAnchorElement>, section: HTMLElement | null) {
    if (section != null) {
        if (e.currentTarget.href !== "/" || window.location.href === "/") {
            e.preventDefault();

            window.scrollTo({
                top: getElementOffsetPos(section),
                behavior: 'smooth'
            });
        }
    }
}
export function scrollToSection(section: HTMLElement | null) {
    if (section != null) {
        window.scrollTo({
            top: getElementOffsetPos(section),
            behavior: 'smooth'
        });
    }
}